// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"
import 'slick-carousel'
// import 'gsap'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import howItWorks from './routes/how-it-works';
import company from './routes/company';
import events from './routes/events';
import singleCareers from './routes/single-careers';
import partners from './routes/partners';
import socialHub from './routes/social-hub';
import parallaxHeader  from './routes/parallax-header';
import mediumZoom  from './routes/medium-zoom';
import faq from './routes/faq';
import resources from './routes/resources';
import BlogLobby from './routes/blogLobby';
import resourcesListing from './routes/resourcesListing';
import news from './routes/news';
import megamenu from './routes/megamenu';
import careerslistfilter from './routes/careers-list-filter';
import extendedDateFacet from './components/extended-date-facet';
import faqRichText from './routes/faq-rich-text';
import AnimateOnScroll from './components/animateOnScroll';
import Gallery from './components/gallery';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // How it works page
  howItWorks,
  // Company page
  company,
  // Events page
  events,
  // Career inner page
  singleCareers,
  // Partners page
  partners,
  // Social Hub
  socialHub,
  // Continuous Impprovement Solutions
  parallaxHeader,
  mediumZoom,
  faq,
  faqRichText,
  resources,
  resourcesListing,
  news,
  megamenu,
  // Career filter
  careerslistfilter,
  extendedDateFacet,
});

// Load Events
jQuery(document).ready(() => {
  const blogLobby = new BlogLobby();
  const animateOnScroll = new AnimateOnScroll();
  const gallery = new Gallery();
  blogLobby.init();
  animateOnScroll.bootstrap();
  gallery.init();

  routes.loadEvents();
});



// WEBPACK FOOTER //
// ./scripts/main.js